$(document).ready(function(){
// Hide all tab content except the first
const tabsContent = document.querySelectorAll('.product-main-tabs .tabs-content > div');
tabsContent.forEach((content, index) => {
    content.style.display = index === 0 ? 'block' : 'none';
});

// Add active class to the first tab
if($('body').hasClass('template-product')){
document.querySelector('.product-tabs li:first-child').classList.add('tab-active');
}

// Change tab class and display content
document.querySelectorAll('.product-tabs a').forEach(tab => {
    tab.addEventListener('click', function(event) {
        event.preventDefault();
        
        // Remove active class from all tabs
        document.querySelectorAll('.product-tabs li').forEach(li => li.classList.remove('tab-active'));
        
        // Add active class to the clicked tab
        this.parentElement.classList.add('tab-active');
        
        // Hide all tab content
        tabsContent.forEach(content => content.style.display = 'none');
        
        // Show the selected tab content
        const activeTab = document.querySelector(this.getAttribute('href'));
        if (activeTab) {
            activeTab.style.display = 'block';
        }
    });
 });


// $(document).on('click','.size-btn',function(){
//   $(".custom-model-main").addClass("model-open");
// });
console.log('hiii load')
document.addEventListener('click', function(event) {
  const sizeBtn = event.target.closest('.size-btn');
  
  if (sizeBtn) {
    document.querySelector('.custom-model-main').classList.add('model-open');
    document.querySelector('body').classList.add('open-size-chart');

    document.querySelectorAll(".close-btn, .bg-overlay").forEach(element => {
      element.addEventListener("click", function () {
        document.querySelector(".custom-model-main").classList.remove("model-open");
        document.querySelector("body").classList.remove("open-size-chart");
      });
    });
  }
});


// document.querySelector(".size-btn").addEventListener("click", function () {
//   document.querySelector(".custom-model-main").classList.add("model-open");
// });

document.querySelectorAll(".close-btn, .bg-overlay").forEach(element => {
  element.addEventListener("click", function () {
    document.querySelector(".custom-model-main").classList.remove("model-open");
    document.querySelector("body").classList.remove("open-size-chart");
  });
});
  
  
  
});

//Ak custom code

//for price range filter
document.addEventListener('DOMContentLoaded', function() {
  const priceWrappers = document.querySelectorAll('.price-range-wrapper');

  priceWrappers.forEach(wrapper => {
    const minRange = wrapper.querySelector('#price-range-min');
    const minHidden = wrapper.querySelector('#price-range-hidden-min');
    const rangeText = wrapper.querySelector('#price-range-text');
    const currency = wrapper.getAttribute('data-currency-symbol');
    const maxPrice = parseFloat(minRange.max);

    // This is the crucial part — read initial value directly from the hidden input
    const initialMinValue = parseFloat(minHidden.value) || 0;

    // Set the slider to match the actual current filter value
    minRange.value = initialMinValue;

    function updatePriceText() {
      const minVal = parseFloat(minRange.value);
      minRange.setAttribute('value', minVal);
      minHidden.value = minVal; // Keep hidden input in sync for Shopify
      minRange.style.setProperty('--value', `${(minRange.value / minRange.max) * 100}%`);
      rangeText.textContent = `${currency}${minVal} - ${currency}${maxPrice}`;
    }

    minRange.addEventListener('input', updatePriceText);
    // Run once on page load to make sure display is correct
    updatePriceText();
  });
});

//end Ak custom code